export const formatDate = (dateString) => {
  const parsedDate = new Date(dateString);

  return parsedDate.toLocaleString("en-US", {
    month: "short",
    day: "2-digit",
    year: "numeric",
    hour12: true,
  });
};


export const GoogleMapsApiKey = "AIzaSyD2zKop1DtokumCZpCMiVR1fMhB9rVARXI";